import React from 'react';

import { IPersonaFront } from '@api/routers/user/service';
import styled from '@emotion/styled';

import { useDeposits } from '@web/features/staking/hooks';

import { SelectedPersona } from './SelectedPersona';

const SelectedPersonasContainer = styled.div<{ amount: number }>`
  display: flex;
  box-sizing: border-box;
  margin-inline: -${({ theme }) => theme.spacing('2000')};
  padding-bottom: ${({ theme }) => theme.spacing('2000')};
  padding-inline: ${({ theme }) => theme.spacing('2000')};
  padding-top: ${({ theme }) => theme.spacing('1500')};
  justify-content: ${({ amount }) => (amount > 2 ? 'flex-start' : 'center')};
  overflow: auto;

  ::-webkit-scrollbar-button:start:increment,
  ::-webkit-scrollbar-button:end:increment {
    width: ${({ theme }) => theme.spacing('2000')};
  }
`;

interface ISelectedPersonasProps {
  personas: Pick<IPersonaFront, 'tokenId' | 'blockchain'>[];
}

export const SelectedPersonas = ({ personas }: ISelectedPersonasProps) => {
  const { depositsRecord } = useDeposits();

  return (
    <SelectedPersonasContainer amount={personas.length}>
      {personas.map((persona, index) => (
        <SelectedPersona
          key={persona.tokenId}
          tokenId={persona.tokenId}
          blockchain={persona.blockchain}
          orderIndex={index + 1}
          isBoosted={!!depositsRecord[persona.tokenId.toString()]?.bonusPerDay}
        />
      ))}
    </SelectedPersonasContainer>
  );
};
